import {connect} from 'react-redux';
import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';

import * as RouteUtils from '../../../utils/Route';
import * as RoutePath from '../../../constants/RoutePaths';
import {setNeedCreateObject} from '../../../actions/CreatingObjectPage';
import {
    logout,
    showRegModal,
    showAuthModal
} from '../../../actions/User';

import {RightSide} from './RightSide';

const defaultProps = {
    logout: () => {
    },
    showRegModal: isShowRegModal => {
    },
    showAuthModal: isShowAuthModal => {
    },
    setNeedCreateObject: isNeedCreateObject => {
    }
};

class Header extends Component {
    constructor(props) {
        super(props);

        this.logout = this.logout.bind(this);
        this.handleRentSaleClick = this.handleRentSaleClick.bind(this);
    }

    logout() {
        const {logout, match, history} = this.props;

        logout();
        if (match.path === RoutePath.CREATING_OBJECT) {
            history.push(RoutePath.HOME);
        }
    }

    handleRentSaleClick() {
        if (this.props.currentUser.accessToken === null) {
            this.props.showAuthModal(true);
        }

        this.props.setNeedCreateObject(true);
    }

    render() {
        const i18n = this.props.languages.i18n;
        let {services, currentUser} = this.props;
        if (services == null) {
            services = [];
        }

        if (this.props.isRedirect && this.props.match.path !== RoutePath.CREATING_OBJECT) {
            return <Redirect to={RouteUtils.getObjectEditPathname(this.props.id)}/>
        } else {
            return (
                <header className="paddings">
                    <Link className="logo" to={RoutePath.HOME}>Rentamanía</Link>
                    <div className="burger"/>
                    <div className="mob_nav">
                        <ul>
                            <li><a href="">{i18n['layout.lifeHacking']}</a></li>
                            {
                                services.map(e =>
                                    <li key={e.id}>
                                        <a href={"/services/" + e.name}>{e.title}</a>
                                    </li>
                                )
                            }
                        </ul>
                    </div>
                    <a href="" className={"link link-article"}>{i18n['layout.lifeHacking']}</a>

                    <div className="link-box">
                        <a href="" className="link link-service">{i18n['layout.services']}</a>
                        <div className="dropdown">
                            <ul>
                                {
                                    services.map(e =>
                                        <li key={e.id}>
                                            <a href={"/services/" + e.name}>{e.title}</a>
                                        </li>
                                    )
                                }
                            </ul>
                        </div>
                    </div>
                    <RightSide
                        i18n={i18n}
                        currentUser={currentUser}
                        logout={this.logout}
                        showAuthModal={this.props.showAuthModal}
                        showRegModal={this.props.showRegModal}
                        handleRentSaleClick={this.handleRentSaleClick}
                    />

                </header>
            )
        }
    }
}

Header.defaultProps = defaultProps;

const mapStateToProps = state => ({
    languages: state.languages,
    services: state.configuration.services,
    currentUser: state.user.currentUser,
    id: state.creatingObjectPage.createdObject.id,
    isRedirect: state.creatingObjectPage.isRedirect
});

const mapDispatchToProps = {
    logout,
    showRegModal,
    showAuthModal,
    setNeedCreateObject
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));



// WEBPACK FOOTER //
// ./src/components/Base/header/Header.js